<div class="digit-span">
  <!-- INTRO / FORWARD DEMO -->
  <ng-container *ngIf="phase === 'intro'">
    <div class="cog-spacer"></div>
    <div class="ds-demo-pill">{{ 'cognitive.sharpV2.echo.demoTag' | translate }}</div>
    <div class="ds-eyebrow">{{ 'cognitive.sharpV2.echo.label' | translate }}</div>
    <h2 class="cog-h2 ds-title">{{ 'cognitive.sharpV2.echo.title' | translate }}</h2>
    <p class="cog-subtitle ds-intro">{{ 'cognitive.sharpV2.echo.subtitle' | translate }}</p>

    <div class="ds-demo-row">
      <span class="ds-demo-cards">
        <span class="ds-demo-card">7</span>
        <span class="ds-demo-card delay">2</span>
      </span>
      <span class="ds-demo-arrow">&larr;</span>
      <span class="ds-demo-hint">{{ 'cognitive.sharpV2.echo.demoYourTurn' | translate }}</span>
    </div>

    <div class="cog-spacer"></div>
    <button type="button" class="cog-btn cog-btn-primary" (click)="beginForward()">
      {{ 'cognitive.sharpV2.echo.start' | translate }}
    </button>
  </ng-container>

  <!-- BETWEEN: backward intro -->
  <ng-container *ngIf="phase === 'between'">
    <div class="cog-spacer"></div>
    <div class="cog-text-center cog-mb-16">
      <h2 class="cog-h2">{{ 'cognitive.sharpV2.echo.backwardTitle' | translate }}</h2>
      <p class="cog-subtitle">{{ 'cognitive.sharpV2.echo.backwardSubtitle' | translate }}</p>
    </div>
    <div class="cog-card cog-card-accent ds-example">
      <p>{{ 'cognitive.sharpV2.echo.exampleShows' | translate }}</p>
      <p class="ds-example-you">{{ 'cognitive.sharpV2.echo.exampleYouTap' | translate }}</p>
    </div>
    <div class="cog-spacer"></div>
    <button type="button" class="cog-btn cog-btn-primary" (click)="beginBackward()">
      {{ 'cognitive.sharpV2.echo.start' | translate }}
    </button>
  </ng-container>

  <!-- INTERRUPTED: the trial is thrown away rather than scored (brief 20.6) -->
  <ng-container *ngIf="phase === 'interrupted'">
    <div class="cog-spacer"></div>
    <div class="cog-text-center cog-mb-16">
      <h2 class="cog-h2">{{ 'cognitive.sharpV2.echo.interruptedTitle' | translate }}</h2>
      <p class="cog-subtitle">{{ 'cognitive.sharpV2.echo.interruptedBody' | translate }}</p>
    </div>
    <div class="cog-spacer"></div>
    <button type="button" class="cog-btn cog-btn-primary" (click)="resumeAfterInterrupt()">
      {{ 'cognitive.sharpV2.echo.interruptedCta' | translate }}
    </button>
  </ng-container>

  <!-- ACTIVE: show / input -->
  <ng-container *ngIf="phase === 'show' || phase === 'input' || phase === 'done'">
    <div class="ds-head">
      <div class="ds-task-title">{{ taskTitleKey | translate }}</div>
      <div class="ds-span-label">
        <ng-container *ngIf="warmup">{{ 'cognitive.sharpV2.echo.warmup' | translate }}</ng-container>
        <ng-container *ngIf="!warmup">{{ 'cognitive.sharpV2.echo.spanOf' | translate: spanParams }}</ng-container>
      </div>
    </div>

    <div class="ds-stage">
      <div class="ds-digit" [class.on]="centerDigit">{{ centerDigit }}</div>
    </div>

    <div class="ds-hint">{{ hintKey | translate }}</div>

    <div class="ds-entry">
      <span *ngFor="let s of slots" class="ds-slot" [class.next]="s.next">{{ s.value }}</span>
    </div>

    <div class="ds-keypad" [class.off]="keypadOff">
      <button *ngFor="let k of keypad" type="button" class="ds-key"
              [disabled]="keypadOff" (click)="tap(k)">{{ k }}</button>
    </div>

    <button
      *ngIf="phase === 'input'"
      type="button"
      class="ds-undo"
      (click)="undo()"
    >{{ 'cognitive.sharpV2.echo.undo' | translate }}</button>
  </ng-container>
</div>
